export const ORDER_SECTION_IDS = {
  main: 'section-main',
  items: 'section-items',
  shipping: 'section-shipping',
  payment: 'section-payment',
  review: 'section-review',
} as const

export type OrderSectionKey = keyof typeof ORDER_SECTION_IDS

export const orderItemCardId = (index: number) => `order-item-card-${index}`
